// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import dayjs from 'dayjs';
import React from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface ExecuteBeforeProps {
  selectedDate?: dayjs.Dayjs;
  onChange: (days: dayjs.Dayjs | null) => void;
  handlePresetDays: (days: number) => void;
}
export const ExecuteBefore: React.FC<ExecuteBeforeProps> = ({
  handlePresetDays,
  selectedDate,
  onChange,
}) => {
  const [selected, setSelected] = React.useState(3);
  const [enableDate, setEnableDate] = React.useState(false);
  const onCustomClick = () => {
    setSelected(0);
    setEnableDate(true);
  };
  const onClick = (days: number) => {
    setEnableDate(false);
    handlePresetDays(days);
    setSelected(days);
  };
  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          // eslint-disable-next-line react/jsx-props-no-spreading
          renderInput={(props) => <TextField fullWidth size="small" {...props} />}
          value={selectedDate}
          onChange={onChange}
          disabled={!enableDate}
        />
        <Stack sx={{ mt: 1 }} direction="row">
          <Button
            sx={{ mr: 0.5 }}
            size="small"
            onClick={() => {
              onClick(3);
            }}
            disableElevation
            fullWidth
            variant={selected === 3 ? 'contained' : 'outlined'}
          >
            3 days
          </Button>
          <Button
            onClick={() => {
              onClick(7);
            }}
            disableElevation
            fullWidth
            size="small"
            variant={selected === 7 ? 'contained' : 'outlined'}
          >
            7 days
          </Button>
          <Button
            sx={{ ml: 0.5 }}
            fullWidth
            disableElevation
            size="small"
            onClick={onCustomClick}
            variant={enableDate ? 'contained' : 'outlined'}
          >
            Custom
          </Button>
        </Stack>
      </LocalizationProvider>
    </Box>
  );
};
